import React from "react";
import { NavLink, useNavigate, Outlet } from "react-router-dom";
import {
  LayoutDashboard, Users, ClipboardList, Calendar as CalIcon,
  UserCog, Receipt, LogOut, Sparkles, PlusCircle,
} from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const navItems = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, tid: "nav-dashboard" },
  { to: "/customers", label: "Customers", icon: Users, tid: "nav-customers" },
  { to: "/jobs", label: "Job Board", icon: ClipboardList, tid: "nav-jobs" },
  { to: "/calendar", label: "Calendar", icon: CalIcon, tid: "nav-calendar" },
  { to: "/employees", label: "Employees", icon: UserCog, tid: "nav-employees" },
  { to: "/invoices", label: "Invoices", icon: Receipt, tid: "nav-invoices" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  return (
    <div className="min-h-screen flex bg-slate-50">
      <aside className="w-64 bg-white border-r border-slate-200 flex flex-col" data-testid="admin-sidebar">
        <div className="px-6 py-6 border-b border-slate-200">
          <div className="flex items-center gap-2">
            <div className="w-9 h-9 rounded-md bg-slate-900 flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-display font-semibold text-base leading-tight">DK-Elite</div>
              <div className="text-xs text-slate-500 leading-tight">Cleaning Manager</div>
            </div>
          </div>
        </div>

        <button
          onClick={() => nav("/booking/new")}
          data-testid="nav-new-booking-btn"
          className="mx-4 mt-4 inline-flex items-center justify-center gap-2 rounded-md bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-3 py-2 transition-colors"
        >
          <PlusCircle className="w-4 h-4" /> New Booking
        </button>

        <nav className="flex-1 px-2 py-4 space-y-0.5">
          {navItems.map(({ to, label, icon: Icon, tid }) => (
            <NavLink
              key={to} to={to} data-testid={tid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 text-sm rounded-md transition-colors ${
                  isActive ? "nav-active" : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`
              }
            >
              <Icon className="w-4 h-4" /> {label}
            </NavLink>
          ))}
        </nav>

        <div className="border-t border-slate-200 p-4">
          <div className="text-xs text-slate-500 mb-1">Signed in as</div>
          <div className="text-sm font-medium text-slate-900 truncate">{user?.name}</div>
          <div className="text-xs text-slate-500 truncate">{user?.email}</div>
          <button
            onClick={async () => { await logout(); nav("/login"); }}
            data-testid="logout-btn"
            className="mt-3 w-full inline-flex items-center justify-center gap-2 text-sm text-slate-700 hover:text-slate-900 border border-slate-200 hover:border-slate-300 rounded-md px-3 py-1.5 transition-colors"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
